import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { CreateButton, useListContext } from 'react-admin';
// import CancelIcon from '@material-ui/icons/Cancel';

export const EmptyList = (props) => {
    const { basePath, resource } = useListContext();
    return (
        <Box textAlign="center" m={1} style={{paddingTop: '60px'}}>
            <Typography variant="h4" paragraph>
                No {props.name} available.
                <br/>
                {/* {(props.close) &&
                <Button label='Close' onClick={props.close} startIcon={<CancelIcon />}></Button>
                } */}
            </Typography>
            <Typography variant="body1">
                Create one
            </Typography>
            <CreateButton style={{marginTop: '50px'}} basePath={basePath} variant='contained'/>
        </Box>
    );
};